import { render, staticRenderFns } from "./TripSearchFilters.vue?vue&type=template&id=b23851f6&scoped=true&"
import script from "./TripSearchFilters.vue?vue&type=script&lang=js&"
export * from "./TripSearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./TripSearchFilters.vue?vue&type=style&index=0&id=b23851f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23851f6",
  null
  
)

/* custom blocks */
import block0 from "./TripSearchFilters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports